<template>
  <div v-if="items.length > 1" class="article-audience-tabs">
    <SvoiTabs :model-value="modelValue" :items="items" @update:model-value="$emit('update:modelValue', $event)" />
  </div>
</template>

<script lang="ts" setup>
import { SvoiTabs } from '@svoi-ui/components/tabs'

defineProps<{
  modelValue: string
  items: string[]
}>()

defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<style lang="scss" scoped>
.article-audience-tabs {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 32px;
  flex-wrap: wrap;

  @include vp-767 {
    gap: 8px;
    margin-bottom: 20px;
  }

  :deep(.svoi-tabs) {
    flex-direction: row;

    >.tabs {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;

      @include vp-767 {
        gap: 8px;
      }

      >.tab {
        padding: 10px 24px;
        border-radius: 12px;
        border: 1px solid $color-default-black;
        background-color: $color-default-white;
        color: $color-default-black;
        font-weight: 400;
        font-size: 16px;
        line-height: 1.5;
        transition: all 0.2s ease;
        white-space: nowrap;

        &:hover {
          background-color: $main-back-color;
        }

        &.-active {
          background-color: $color-default-black;
          color: $color-default-white;

          &:hover {
            background-color: $color-potato-90;
          }
        }

        @include vp-767 {
          padding: 8px 16px;
          font-size: 14px;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
